import createIcon from '../../createIcon';

/**
 * @component @name EnergySavingsLeaf
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgM0M3LjIgMyAzIDYuODYgMyAxMkMzIDE0LjEyIDMuNzQgMTYuMDcgNC45NyAxNy42MUwzIDE5LjU5TDQuNDEgMjFMNi4zOCAxOS4wM0M3LjkzIDIwLjI2IDkuODggMjEgMTIgMjFDMTQuMyAyMSAxNi42MSAyMC4xMiAxOC4zNiAxOC4zNkMyMC4xMiAxNi42MSAyMSAxNC4zIDIxIDEyVjNIMTJaTTE1LjgzIDEyLjI2TDEwLjY3IDE2Ljg5QzEwLjUxIDE3LjA0IDEwLjI2IDE3LjAzIDEwLjExIDE2Ljg4QzkuOTcgMTYuNzQgOS45NSAxNi41MiAxMC4wNyAxNi4zNkwxMi41MSAxMy4wM0w4LjQ2IDEyLjYzQzguMDIgMTIuNTkgNy44MyAxMi4wNCA4LjE2IDExLjc0TDEzLjMyIDcuMTFDMTMuNDggNi45NiAxMy43MyA2Ljk3IDEzLjg4IDcuMTJDMTQuMDIgNy4yNiAxNC4wNCA3LjQ4IDEzLjkyIDcuNjRMMTEuNDggMTAuOTdMMTUuNTMgMTEuMzdDMTUuOTggMTEuNDEgMTYuMTYgMTEuOTYgMTUuODMgMTIuMjZaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const EnergySavingsLeaf = createIcon('EnergySavingsLeaf', [
  [
    'path',
    {
      d: 'M12 3C7.2 3 3 6.86 3 12C3 14.12 3.74 16.07 4.97 17.61L3 19.59L4.41 21L6.38 19.03C7.93 20.26 9.88 21 12 21C14.3 21 16.61 20.12 18.36 18.36C20.12 16.61 21 14.3 21 12V3H12ZM15.83 12.26L10.67 16.89C10.51 17.04 10.26 17.03 10.11 16.88C9.97 16.74 9.95 16.52 10.07 16.36L12.51 13.03L8.46 12.63C8.02 12.59 7.83 12.04 8.16 11.74L13.32 7.11C13.48 6.96 13.73 6.97 13.88 7.12C14.02 7.26 14.04 7.48 13.92 7.64L11.48 10.97L15.53 11.37C15.98 11.41 16.16 11.96 15.83 12.26Z',
      key: '1t5f72',
    },
  ],
]);

export default EnergySavingsLeaf;
